import { useState } from 'react';
import { ButtonField, Modal, ModalHeader, ModalBody, ModalFooter, ButtonGroup, ButtonGroupItem, InputField } from '@wk/components-react16';
import { API_URL } from '../../../config/constants';
import HttpService from "../../../config/http.service";
import { Toast } from '../../../services';

const AddProject = ({ data }: any) => {
    const { isOpenAddEdit, setIsOpenAddEdit, selectedItem, setIsLoad } = data;
    const defaultFormObj = {
        name: selectedItem.name ? selectedItem.name : '',
        code: selectedItem.code ? selectedItem.code : '',
        id: selectedItem.id ? selectedItem.id : null
    };
    const [formField, setFormField] = useState(defaultFormObj);

    const handleUserRequest = (origin: string) => {
        if (origin === 'esc' || origin === 'header' || origin === 'footer') {
            setIsOpenAddEdit(false);
        }
    }

    const handleInputChange = (event: any) => {
        const { name, value } = event.target;
        setFormField({
            ...formField,
            [name]: value,
        });
    };

    const generateCode = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter project name', "error");
            return false;
        }
        HttpService.postRequest(API_URL.GENERATE_CODE, formField.name).then(
            (res: any) => {
                setFormField({
                    ...formField,
                    code: res ? res : null
                });
            }
        ).catch((err: any) => {
            Toast(err.message, "error");
        });
    }

    const isValid = () => {
        if (!formField.name || !formField.name.trim()) {
            Toast('Please enter project name', "error");
            return false;
        }
        if (!formField.code || !formField.code.trim()) {
            Toast('Please enter project code', "error");
            return false;
        }
        return true;
    };

    const handleAddProject = async () => {
        if (!isValid()) return;
        HttpService.postRequest(API_URL.ADD_PROJECT, formField).then(
            (res: any) => {
                Toast(selectedItem?.id ? "Project updated successfully." : "Project added successfully.", "success");
                setIsLoad(true);
                setIsOpenAddEdit(false);
            },
            (err: any) => {
                Toast(err.message, "error")
            },
        )
    }

    return (
        <div>
            <Modal
                isOpen={isOpenAddEdit}
                srLabelledBy={'modal-id-project'}
                srDescribedBy={'modal-id-project'}
                onUserRequest={handleUserRequest}>
                <ModalHeader
                    titleId={'modal-id-project'}
                    isFullscreenButtonVisible={false}
                    onUserRequest={() => handleUserRequest('header')}>
                    {selectedItem?.id ? 'Edit Project' : 'Add Project'}
                </ModalHeader>
                <ModalBody descriptionId="modal-id-project">
                    <div className='wk-grid-page-container p-0'>
                        <div className='wk-row mb-10'>
                            <div className="wk-col-12">
                                <InputField label="Project Name" labelFor="project-name" size="small" indicator="required">
                                    <input
                                        type="text" id="project-name" name="name"
                                        placeholder="Project Name"
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.name} autoComplete="off"
                                    />
                                </InputField>
                                <div className="cg-field-header">
                                    <label className="cg-field-label pt-15">Project Code <div className="cg-field-required-indicator"><span aria-hidden="true">*</span><div data-e2e="cg-sr-only" className="cg-sr-only">Required field</div></div></label>
                                    <div className="pt-5">
                                        <button type="button" className="border border-primary btn btn btn-outline-light text-bg-light"
                                            style={{ padding: '.25rem .5rem', fontSize: '.75rem', color: '#9A67F3' }}
                                            onClick={generateCode}>
                                            Generate Code
                                        </button>
                                    </div>
                                </div>
                                <InputField label="" labelFor="project-code" size="small" indicator="required">
                                    <input
                                        type="text" id="project-code" name="code"
                                        placeholder="Project Code"
                                        readOnly
                                        onChange={(event: any) => handleInputChange(event)}
                                        value={formField.code} autoComplete="off"
                                    />
                                </InputField>
                            </div>
                        </div>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ButtonGroup mode="static">
                        <ButtonGroupItem slot="buttonGroupItem">
                            <ButtonField size={'small'} mode={'ghost'}>
                                <button type="button" className="mr-10"
                                    onClick={() => handleUserRequest('footer')}>
                                    Cancel
                                </button>
                            </ButtonField>
                            <ButtonField size={'small'}>
                                <button
                                    type="button"
                                    id="save"
                                    onClick={handleAddProject}>
                                    Save
                                </button>
                            </ButtonField>
                        </ButtonGroupItem>
                    </ButtonGroup>
                </ModalFooter>
            </Modal>
        </div>
    );
};

export default AddProject;